
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitopunecab() {



    const cardData =
    {
        keyword: 'Navi Mumbai to Pune Cab',
        heading: 'Skyline Cabs: Navi Mumbai to Pune Cab ',
        headingDescription: 'Skyline Cabs offers reliable and affordable Navi Mumbai to Pune Cab services for a smooth and comfortable journey. Whether you are traveling for work, leisure, or airport transfers, our well-maintained vehicles and experienced drivers ensure a safe, timely, and hassle-free ride. With transparent pricing, door-to-door service, and 24/7 availability, Skyline Cabs is your trusted travel partner from Navi Mumbai to Pune. Book your cab today and enjoy a comfortable and convenient travel experience.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Navi Mumbai to Pune Taxi",
      "description": "Skyline Cabs provides seamless and affordable taxi service from Navi Mumbai to Pune. Whether you're traveling for business, leisure, or airport transfers, enjoy a stress-free journey with professional drivers and AC vehicles."
    },
    {
      "name": "Navi Mumbai to Pune Taxi Fare",
      "description": "Get the most competitive and transparent taxi fares from Navi Mumbai to Pune with Skyline Cabs. All charges include tolls, taxes, and driver fees—no hidden costs. Choose from multiple cab options including sedans, Ertiga, and Innova Crysta."
    },
    {
      "name": "Navi Mumbai to Pune One Way Taxi",
      "description": "Looking for a one-way drop from Navi Mumbai to Pune? Skyline Cabs offers budget-friendly, reliable, and on-time one-way taxi services with a wide range of vehicle choices and flexible pickup times."
    },
    {
      "name": "Navi Mumbai to Pune Innova Taxi",
      "description": "Book a spacious and luxurious Innova Crysta from Navi Mumbai to Pune. Ideal for families or groups, Skyline Cabs ensures a comfortable and safe travel experience with experienced chauffeurs."
    },
    {
      "name": "Navi Mumbai to Pune Ertiga Taxi",
      "description": "Travel comfortably from Navi Mumbai to Pune in an Ertiga with Skyline Cabs. Enjoy a spacious ride that’s ideal for groups or luggage-heavy trips at affordable prices with timely service."
    },
    {
      "name": "Navi Mumbai to Pune Sedan Cab",
      "description": "For solo or small group travel, Skyline Cabs offers sedan cabs from Navi Mumbai to Pune. Book Swift Dzire, Etios, or Xcent for a clean, air-conditioned, and smooth ride at budget rates."
    },
    {
      "name": "Navi Mumbai to Pune Round Trip Cab",
      "description": "Need a cab for a same-day return or short stay in Pune? Skyline Cabs offers round-trip bookings from Navi Mumbai to Pune with discounted return fares and complete driver assistance throughout your journey."
    },
    {
      "name": "Navi Mumbai to Hinjewadi Cab",
      "description": "Skyline Cabs offers direct cab service from Navi Mumbai to Pune's IT hub – Hinjewadi. Get fast, convenient, and safe transfers with options like sedan, Ertiga, or Innova Crysta for a smooth commute."
    },
    {
      "name": "Pune to Navi Mumbai Cab",
      "description": "Need to return from Pune to Navi Mumbai? Skyline Cabs provides punctual and well-equipped cabs for hassle-free travel, ensuring comfort and safety for individuals, families, or business travelers."
    },
    {
      "name": "Cab Service in Navi Mumbai",
      "description": "Skyline Cabs is your go-to provider for reliable cab service in Navi Mumbai. Offering local, airport, and outstation rides, our fleet includes sedans, Ertiga, and Innova with 24/7 availability and trained drivers."
    },
    {
      "name": "Cab Hire in Navi Mumbai",
      "description": "Hire a cab in Navi Mumbai with Skyline Cabs for local trips, outstation journeys, or airport transfers. Choose from an extensive fleet and book instantly through our easy-to-use platform or helpline."
    },
    {
      "name": "Cab Service in Airoli",
      "description": "Skyline Cabs offers top-rated cab services in Airoli. Get safe and affordable rides to Pune or Mumbai Airport with our well-maintained vehicles and experienced chauffeurs."
    },
    {
      "name": "Cabs in Navi Mumbai",
      "description": "Book affordable and reliable cabs in Navi Mumbai with Skyline Cabs. From local travel to long-distance trips to Pune, we provide 24/7 service with flexible car options and real-time booking support."
    },
    {
      "name": "Kharghar Taxi Service",
      "description": "Need a taxi from Kharghar to Pune or nearby areas? Skyline Cabs has you covered with punctual pickups, experienced drivers, and sanitized vehicles for safe and affordable travel."
    },
    {
      "name": "Taxi Service in Vashi Navi Mumbai",
      "description": "Skyline Cabs provides premium taxi services in Vashi, Navi Mumbai. Ideal for both local and long-distance travel, our services include outstation trips, airport transfers, and daily commutes."
    },
    {
      "name": "Innova Crysta on Rent in Navi Mumbai",
      "description": "Rent an Innova Crysta in Navi Mumbai with Skyline Cabs for outstation trips or family travel. Enjoy luxurious interiors, spacious seating, and reliable drivers for a smooth experience."
    },
    {
      "name": "Ertiga on Rent in Navi Mumbai",
      "description": "Looking for a practical and comfortable ride? Skyline Cabs offers Ertiga on rent in Navi Mumbai for affordable travel to Pune and other destinations. Perfect for small groups and families."
    },
    {
      "name": "Outstation Cabs in Navi Mumbai",
      "description": "Skyline Cabs provides reliable outstation cabs from Navi Mumbai to Pune and other cities. Book round-trip or one-way options with upfront pricing and safe travel experience."
    }
  ],
  "tableData": [
    ["Navi Mumbai to Pune Taxi", "Navi Mumbai to Pune Taxi Fare"],
    ["Navi Mumbai to Pune One Way Taxi", "Navi Mumbai to Pune Innova Taxi"],
    ["Navi Mumbai to Pune Ertiga Taxi", "Navi Mumbai to Pune Sedan Cab"],
    ["Navi Mumbai to Pune Round Trip Cab", "Navi Mumbai to Hinjewadi Cab"],
    ["Pune to Navi Mumbai Cab", "Cab Service in Navi Mumbai"],
    ["Cab Hire in Navi Mumbai", "Cab Service in Airoli"],
    ["Cabs in Navi Mumbai", "Kharghar Taxi Service"],
    ["Taxi Service in Vashi Navi Mumbai", "Innova Crysta on Rent in Navi Mumbai"],
    ["Ertiga on Rent in Navi Mumbai", "Outstation Cabs in Navi Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Dependable Navi Mumbai to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and efficient cab service from Navi Mumbai to Pune, ensuring a hassle-free experience for commuters. Whether you're traveling for work, leisure, or to catch a flight, we guarantee on-time pickups and a smooth ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Fleet",
        "WhyChoosedescription": "Enjoy a relaxing ride in our air-conditioned, spacious vehicles. Our fleet includes clean and comfortable sedans, SUVs, and luxury cars that are regularly serviced and sanitized—ensuring a safe and pleasant journey from Navi Mumbai to Pune for all passengers."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our drivers are courteous, experienced, and fully familiar with the Navi Mumbai to Pune route. They take the most efficient paths to avoid traffic, ensuring a smooth and timely trip while prioritizing your comfort and safety throughout the journey."
    },
    {
        "WhyChooseheading": "Affordable Rates with Transparent Billing",
        "WhyChoosedescription": "With Skyline Cabs, you’ll always know what you’re paying for. Our pricing is transparent, competitive, and completely free from hidden fees. Whether it's a one-way or round-trip, our fare structure is designed to offer top-quality service at the best value."
    },
    {
        "WhyChooseheading": "24/7 Availability for Anytime Travel",
        "WhyChoosedescription": "We understand that travel plans can change or arise unexpectedly. That's why Skyline Cabs operates 24/7, allowing you to book a cab from Navi Mumbai to Pune at any hour, day or night, with complete peace of mind."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options for Every Traveler",
        "WhyChoosedescription": "No matter your group size or budget, Skyline Cabs has the right vehicle for your trip. From compact sedans for individuals to spacious SUVs for families or corporate groups, we ensure that your ride is both comfortable and tailored to your travel needs."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Live Tracking",
        "WhyChoosedescription": "Book your Navi Mumbai to Pune cab in just a few taps using our website or app. Enjoy features like instant confirmation, live tracking, driver contact info, and secure digital payments, making your booking process smooth and convenient."
    },
    {
        "WhyChooseheading": "Safe and Secure Intercity Travel",
        "WhyChoosedescription": "Your safety is our highest priority. All Skyline cabs are GPS-enabled, thoroughly sanitized, and driven by background-verified professionals. Whether it’s an early morning trip or a late-night ride, you can count on us for a safe, worry-free journey."
    }
]





















    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Navi Mumbai to Pune with Skyline Cabs?',
            answer:
                'You can book easily through our website or mobile app. Select Navi Mumbai as your pickup location and Pune as the destination, choose your vehicle, and confirm your ride in just a few clicks.',
        },
        {
            id: 2,
            question: 'Which areas in Navi Mumbai do you cover?',
            answer:
                'We provide pickups from all major Navi Mumbai areas including Vashi, Belapur, Nerul, Airoli, Kharghar, and Panvel. Just enter your exact pickup point while booking.',
        },
        {
            id: 3,
            question: 'What types of cars are available for this route?',
            answer:
                'Skyline Cabs offers Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can choose the car type based on your comfort and the number of passengers.',
        },
        {
            id: 4,
            question: 'Is the fare from Navi Mumbai to Pune fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. The fare includes tolls, driver fees, and taxes — no surprises or hidden charges.',
        },
        {
            id: 5,
            question: 'How long does the trip from Navi Mumbai to Pune take?',
            answer:
                'It usually takes around 2.5 to 4 hours depending on traffic conditions and pickup location in Navi Mumbai. Our drivers take the safest and fastest routes.',
        },
        {
            id: 6,
            question: 'Can I book a round-trip cab?',
            answer:
                'Yes, you can opt for both one-way and round-trip bookings. Just provide your return date and time while booking and we’ll handle the rest.',
        },
        {
            id: 7,
            question: 'Are the cabs available 24/7 from Navi Mumbai?',
            answer:
                'Yes, Skyline Cabs operates round the clock. Whether it’s an early morning meeting or a late-night journey, we’re ready when you are.',
        },
        {
            id: 8,
            question: 'Is it safe to travel solo in your cabs?',
            answer:
                'Absolutely. All our drivers are background-verified and professionally trained. Solo travelers, especially women, can ride with full peace of mind.',
        },
        {
            id: 9,
            question: 'Do you provide cabs from Navi Mumbai Railway or Bus Station?',
            answer:
                'Yes, we offer pickup from all major transport points in Navi Mumbai including local railway stations and bus depots. Just mention your location while booking.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Navi Mumbai to Pune?',
            answer:
                'Skyline Cabs offers reliable service, clean cars, courteous drivers, and all-inclusive pricing. We make your Navi Mumbai to Pune journey stress-free, every time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Sandeep Patil",
            rating: 5,
            review: "Booked a cab from Kharghar to Pune for a client meeting. The driver was punctual and courteous, the car was spotless, and the ride was very smooth. Skyline Cabs is now my go-to for intercity trips!"
        },
        {
            name: "Miss. Ananya Deshmukh",
            rating: 4,
            review: "I traveled from Vashi to Pune alone and felt completely safe throughout the journey. The car was clean and the driver was polite. Would love if they added snacks or water for longer trips!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-pune-cab.jpg",
  "description": "Book Navi Mumbai to Pune cabs with Skyline Cabs for safe, affordable, and comfortable travel. Choose from AC sedans or SUVs with verified drivers—available 24/7 for one-way and round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7965"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-pune-cabs"
  }
};



      
      
      



    return (
        <div>
<Helmet>
  <title>Navi Mumbai to Pune Cabs | AC Taxi 24/7 Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Pune cabs with Skyline Cabs for safe, affordable, and comfortable travel. Choose from AC sedans or SUVs with verified drivers—available 24/7 for one-way and round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Navi Mumbai to Pune Cabs, Cab from Navi Mumbai to Pune, One-Way Taxi Navi Mumbai to Pune, Round Trip Cab Navi Mumbai to Pune, AC Cab Navi Mumbai to Pune, SUV Taxi Navi Mumbai to Pune, Skyline Cabs Navi Mumbai to Pune, Online Cab Booking Navi Mumbai Pune, Affordable Taxi Navi Mumbai to Pune, 24/7 Cab Navi Mumbai to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitopunecab;